import { render, staticRenderFns } from "./ScheduleNotificationType.vue?vue&type=template&id=36048eb0&scoped=true&"
import script from "./ScheduleNotificationType.vue?vue&type=script&lang=js&"
export * from "./ScheduleNotificationType.vue?vue&type=script&lang=js&"
import style0 from "./ScheduleNotificationType.vue?vue&type=style&index=0&id=36048eb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36048eb0",
  null
  
)

export default component.exports